/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import blueEmployeeIcon from '../../../../assets/images/icons/blueEmployeeIcon.svg';
import blueEmployeeIconOpc from '../../../../assets/images/icons/blueEmployeeIconOpc.svg';
import company from '../../../../assets/images/icons/companyMapDataView.svg';
import employeeIcon from '../../../../assets/images/icons/employee.svg';
import employeeIconOpc from '../../../../assets/images/icons/employeeOpc.svg';
import greenEmployeeIcon from '../../../../assets/images/icons/greenEmployeeIcon.svg';
import greenEmployeeIconOpc from '../../../../assets/images/icons/greenEmployeeIconOpc.svg';
import orangeEmployeeIcon from '../../../../assets/images/icons/orangeEmployeeIcon.svg';
import orangeEmployeeIconOpc from '../../../../assets/images/icons/orangeEmployeeIconOpc.svg';
import redEmployeeIcon from '../../../../assets/images/icons/redEmployeeIcon.svg';
import redEmployeeIconOpc from '../../../../assets/images/icons/redEmployeeIconOpc.svg';
// import purpleEmployeeIcon from '../../../../assets/images/icons/purpleEmployeeIcon.svg';
import useApiCall from '../../../../hooks/useApiCall';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import ConsultsService from '../../../../services/ConsultsService';
import floatToCurrency from '../../../../utils/floatToCurrency';
import formatCurrencyMapDataView from '../../../../utils/formatCurrencyMapDataView';
import OpacityAnimation from '../../../OpacityAnimation';
import { ValeTransp } from '../../../RoutingResult/types';
import { FullDataType, WorkplaceType } from '../../types';

interface DisplayMapInterface {
  data: FullDataType[];
  selectedWorkplace: WorkplaceType;
  selectedEmployee: { value: string, label: string };
  selectedColorView: 'criminalRisc' | 'optimizationStatus';
  employeesChecked: string[];
  checkEmployee: (employee: string) => void;
  uncheckEmployee: (employee: string) => void;
}

type CoordType = { lat: string, lng: string };

export type EmployeeMapItem = {
  lat: string;
  lng: string;
  name: string;
  cpf: string;
  companyCode: string;
  cpfWithoutMask: string;
  consultCode: string;
  oldValue: string;
  newValue: string;
  savedValue: number;
  optimized: boolean;
  streetName: string;
  number: string;
  cep: string;
  entryTime: string;
  exitTime: string;
  highlighted: boolean;
  criminalRisc: string;
};

export function buildTicketsListHtml(tickets: ValeTransp[]): string {
  if (!tickets || tickets.length === 0) {
    return `<div style="
      background: #f8fafc;
      border: 1px solid #cbd5e1;
      border-radius: 6px;
      padding: 6px 10px;
      margin: 4px 0;
      font-size: 11px;
      color: #64748b;
      text-align: center;
    ">
      Nenhum item de vale transporte encontrado.
    </div>`;
  }

  const totalVt = tickets.reduce((acc, curr) => acc + (Number(curr.totVt) || 0), 0);

  const itemsHtml = tickets.map((ticket) => {
    const isMaintained = ticket.codVT === 1758;
    if (isMaintained) {
      return `
        <div style="
          padding: 4px 0;
          border-bottom: 1px dashed #cbd5e1;
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 11px;
        ">
          <span style="font-weight: 600; color: #0c2c54;">Transporte Mantido</span>
        </div>
      `;
    }

    const opName = ticket.operadora || 'Operadora';
    const type = ticket.tipoTransp || 'Transporte';
    const tariff = floatToCurrency(ticket.tarifaVt || 0);
    const subtotal = floatToCurrency(ticket.totVt || 0);

    return `
      <div style="
        padding: 5px 0;
        border-bottom: 1px dashed #cbd5e1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        font-size: 11px;
      ">
        <div style="display: flex; flex-direction: column; text-align: left;">
          <span style="font-weight: 600; color: #0c2c54;">
            ${ticket.qtdVt}x ${opName}
          </span>
          <span style="font-size: 10px; color: #64748b;">
            ${tariff} - ${type}
          </span>
        </div>
        <div style="font-weight: 700; color: #0075b2; white-space: nowrap; text-align: right;">
          ${subtotal}
        </div>
      </div>
    `;
  }).join('');

  return `
    <div style="
      background: #f8fafc;
      border: 1px solid #cbd5e1;
      border-radius: 6px;
      padding: 8px 10px;
      margin: 4px 0;
      min-width: 230px;
    ">
      <div style="
        font-size: 11px;
        font-weight: 700;
        color: #0c2c54;
        margin-bottom: 4px;
        border-bottom: 1px solid #cbd5e1;
        padding-bottom: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      ">
        <span>Itens da Roteirização:</span>
        <span style="font-size: 10px; font-weight: 500; color: #64748b;">${tickets.length} ${tickets.length === 1 ? 'item' : 'itens'}</span>
      </div>

      <div style="max-height: 150px; overflow-y: auto;">
        ${itemsHtml}
      </div>

      <div style="
        margin-top: 6px;
        padding-top: 4px;
        border-top: 1px solid #cbd5e1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 11px;
        font-weight: 700;
        color: #0c2c54;
      ">
        <span>Total por dia:</span>
        <span style="color: #0075b2; font-size: 12px;">${floatToCurrency(totalVt)}</span>
      </div>
    </div>
  `;
}

export function buildEmployeeInfoBubbleHtml(employee: EmployeeMapItem, tickets?: ValeTransp[]): string {
  const isRouted = Number(employee.newValue) > 0;

  let ticketsSection = '';
  if (isRouted) {
    if (tickets) {
      ticketsSection = `
        <div id="bubble-tickets-container-${employee.consultCode}" style="margin-top: 6px; margin-bottom: 6px;">
          ${buildTicketsListHtml(tickets)}
        </div>
      `;
    } else {
      ticketsSection = `
        <div id="bubble-tickets-container-${employee.consultCode}" style="margin-top: 6px; margin-bottom: 6px;">
          <button
            type="button"
            id="btn-view-tickets-${employee.consultCode}"
            style="
              background: #0c2c54;
              color: #ffffff;
              border: none;
              border-radius: 4px;
              padding: 6px 10px;
              font-size: 11px;
              font-weight: 600;
              cursor: pointer;
              display: block;
              width: 100%;
              text-align: center;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#134480'"
            onmouseout="this.style.background='#0c2c54'"
            onclick="window.dispatchEvent(new CustomEvent('load-routing-tickets', { detail: { consultCode: '${employee.consultCode}', companyCode: '${employee.companyCode}' } }))"
          >
            Ver itens usados na roteirização
          </button>
        </div>
      `;
    }
  }

  return `<div style="
    min-inline-size: max-content;
  ">
    CPF: ${employee.cpf}
    <br>
    <a href="/consults/result/${employee.consultCode}?codEmpresa=${employee.companyCode}&activeSidebar=SearchConsults&returnLink=${encodeURIComponent('/consults/search')}" target="_blank" rel="noreferrer">
    Consulta: ${employee.consultCode}
    </a>
    <br>
    VT Informado: ${formatCurrencyMapDataView(Number(employee.oldValue))}
    <br>
    VT Roteirizado: ${formatCurrencyMapDataView(Number(employee.newValue))}
    ${ticketsSection}
    <br>
    Status: ${employee.optimized ? 'Otimizado' : 'Não otimizado'}
    <br>
    Economia: ${formatCurrencyMapDataView((employee.savedValue))}
    <br>
    Horário: ${employee.entryTime} - ${employee.exitTime}
    <br>
    Endereço: ${employee.streetName}, ${employee.number} - ${employee.cep}
    <br>
    Risco Criminalidade: ${employee.criminalRisc}
  </div>`;
}

export default function DisplayMap({
  data,
  selectedColorView,
  selectedWorkplace,
  selectedEmployee,
  employeesChecked,
  checkEmployee,
  uncheckEmployee,
}: DisplayMapInterface) {
  const { apiCall } = useApiCall();
  const { userCode, userProfile } = useGetGeneralAppData();
  const ticketsCacheRef = useRef<Record<string, ValeTransp[]>>({});
  const markersByConsultRef = useRef<Record<string, any>>({});
  const employeesByConsultRef = useRef<Record<string, EmployeeMapItem>>({});

  const [zoom, setZoom] = useState(10.5);
  const [center, setCenter] = useState({ lat: 0, lng: 0 });
  const mapRef = useRef(null);

  useLayoutEffect(() => {
    const employees = data.map((i) => (
      {
        lat: i.employeeLat,
        lng: i.employeeLng,
        name: i.name,
        cpf: `•••.•••.${i.cpf?.slice(8, 16)}`,
        companyCode: i.companyCode,
        cpfWithoutMask: i.cpf,
        consultCode: i.consultCode,
        oldValue: i.oldValue,
        newValue: i.newValue,
        savedValue: Number(i.oldValue) - Number(i.newValue),
        optimized: Number(i.newValue) < Number(i.oldValue),
        streetName: i.employeeStreetName,
        number: i.employeeNumber,
        cep: i.employeeCep,
        entryTime: i.entryTime,
        exitTime: i.exitTime,
        highlighted: i.highlighted,
        criminalRisc: i.criminalRisc,
      }
    ));
    const selectedEmployeeData = employees.find((employee) => employee.cpfWithoutMask === selectedEmployee.value.split(' ')[0]);
    const ltCoords = { lat: selectedWorkplace.lat, lng: selectedWorkplace.lng };

    if (!mapRef.current) return undefined;
    const { H } = window;
    const platform = new H.service.Platform({
      apikey: process.env.REACT_APP_HERE_KEY,
    });
    const defaultLayers = platform.createDefaultLayers();
    // Create an instance of the map
    const mapInstance = new H.Map(
      mapRef.current,
      defaultLayers.vector.normal.map,
      {
        center: selectedEmployee?.value
          ? { lat: selectedEmployeeData?.lat, lng: selectedEmployeeData?.lng }
          : center.lat ? center : ltCoords,
        zoom: zoom || 10.5,
        pixelRatio: window.devicePixelRatio || 1,
      },
    );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(mapInstance));
    const ui = H.ui.UI.createDefault(mapInstance, defaultLayers);

    function addMarkersToMap(map: any) {
      const ltIcon = new H.map.Icon(company, {
        size: {
          h: 32,
          w: 32
        }
      });
      const ltMarker = new H.map.Marker(ltCoords, { icon: ltIcon });
      function addMarkerToGroup(group: any, coordinate: CoordType, html: string) {
        const marker = new H.map.Marker(coordinate, { icon: ltIcon });
        // add custom data to the marker
        marker.setData(html);
        group.addObject(marker);
      }
      function addInfoBubble(mp: any) {
        const group = new H.map.Group();
        mp.addObject(group);

        // add 'tap' event listener, that opens info bubble, to the group
        group.addEventListener('tap', (evt: any) => {
          // event target is the marker itself, group is a parent event target
          // for all objects that it contains
          const bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
            // read custom data
            content: evt.target.getData(),
          });
          // show info bubble
          ui.addBubble(bubble);
        }, false);

        addMarkerToGroup(
          group,
          ltCoords,
          `<div style="
              min-inline-size: max-content;
          ">
            ${selectedWorkplace.label}
            <br>
            Código: ${selectedWorkplace.value}
            <br>
            Endereço: ${selectedWorkplace.streetName}, ${selectedWorkplace.number} - ${selectedWorkplace.cep}
          </div>`,
        );
      }
      map.addObject(ltMarker);
      addInfoBubble(map);

      employees.forEach((employee) => {
        const isEmployeeChecked = employeesChecked.includes(employee.cpfWithoutMask);

        const optimizedEmployeeIcon = new H.map.Icon(isEmployeeChecked ? greenEmployeeIconOpc : greenEmployeeIcon);
        const notOptimizedEmployeeIcon = new H.map.Icon(isEmployeeChecked ? employeeIconOpc : employeeIcon);
        const highCriminalRiscEmployeeIcon = new H.map.Icon(isEmployeeChecked ? redEmployeeIconOpc : redEmployeeIcon);
        const mediumCriminalRiscEmployeeIcon = new H.map.Icon(isEmployeeChecked ? orangeEmployeeIconOpc : orangeEmployeeIcon);
        const selectedEmployeeIcon = new H.map.Icon(isEmployeeChecked ? blueEmployeeIconOpc : blueEmployeeIcon);
        const employeeCoord = { lat: employee.lat, lng: employee.lng };

        function getChoosedIcon() {
          if (selectedColorView === 'optimizationStatus') {
            const choosedIconOptimizationView = (
              employee.cpfWithoutMask === selectedEmployee.value.split(' ')[0]
                ? selectedEmployeeIcon
                : (employee.optimized ? optimizedEmployeeIcon : notOptimizedEmployeeIcon)
            );
            return choosedIconOptimizationView;
          }

          const iconByCriminalRiscMap: { [key: string]: any } = {
            'Alto Risco': highCriminalRiscEmployeeIcon,
            'Médio Risco': mediumCriminalRiscEmployeeIcon,
            'Baixo Risco': optimizedEmployeeIcon,
            'Sem Índice': notOptimizedEmployeeIcon,
          };
          const choosedIconCriminalRiscView =  employee.cpfWithoutMask === selectedEmployee.value.split(' ')[0] ? selectedEmployeeIcon : iconByCriminalRiscMap[employee.criminalRisc];
          return choosedIconCriminalRiscView;
        }

        employeesByConsultRef.current[employee.consultCode] = employee;
        const cachedTickets = ticketsCacheRef.current[employee.consultCode];

        const choosedIcon = getChoosedIcon();
        const employeeMarker = new H.map.Marker(employeeCoord, { icon: choosedIcon });

        function addMarkerToGroup(group: any, coordinate: CoordType, html: string) {
          const marker = new H.map.Marker(coordinate, { icon: choosedIcon });
          // add custom data to the marker
          marker.setData(html);
          markersByConsultRef.current[employee.consultCode] = marker;
          group.addObject(marker);
        }

        function addInfoBubble(mp: any) {
          const group = new H.map.Group();
          mp.addObject(group);

          // add 'tap' event listener, that opens info bubble, to the group
          group.addEventListener('tap', (evt: any) => {
            // event target is the marker itself, group is a parent event target
            // for all objects that it contains
            const bubble = new H.ui.InfoBubble(evt.target.getGeometry(), {
              // read custom data
              content: evt.target.getData(),
            });
            // show info bubble
            ui.addBubble(bubble);
          }, false);

          group.addEventListener('longpress', () => {
            const currentZoom = mapInstance.getZoom();
            const currentCenter = mapInstance.getCenter();
            setZoom(currentZoom);
            setCenter(currentCenter);

            if (isEmployeeChecked) {
              uncheckEmployee(employee.cpfWithoutMask);
            } else {
              checkEmployee(employee.cpfWithoutMask);
            }
          }, false);

          addMarkerToGroup(
            group,
            employeeCoord,
            buildEmployeeInfoBubbleHtml(employee, cachedTickets),
          );
        }
        map.addObject(employeeMarker);
        addInfoBubble(map);
      });
    }

    addMarkersToMap(mapInstance);
    return () => {
      mapInstance.dispose();
    };
  }, [center, checkEmployee, data, employeesChecked, mapRef, selectedColorView, selectedEmployee, selectedWorkplace, uncheckEmployee, zoom]);

  useEffect(() => {
    const handleLoadTickets = async (event: Event) => {
      const customEvent = event as CustomEvent<{
        consultCode: string;
        companyCode: string;
      }>;
      if (!customEvent.detail) return;
      const { consultCode, companyCode } = customEvent.detail;

      const container = document.getElementById(`bubble-tickets-container-${consultCode}`);
      const btn = document.getElementById(`btn-view-tickets-${consultCode}`) as HTMLButtonElement | null;

      // Se já está no cache, exibe imediatamente
      if (ticketsCacheRef.current[consultCode]) {
        const cached = ticketsCacheRef.current[consultCode];
        if (container) {
          container.innerHTML = buildTicketsListHtml(cached);
        }
        const emp = employeesByConsultRef.current[consultCode];
        if (emp && markersByConsultRef.current[consultCode]) {
          markersByConsultRef.current[consultCode].setData(buildEmployeeInfoBubbleHtml(emp, cached));
        }
        return;
      }

      // Mostra feedback de carregando no botão
      if (btn) {
        btn.disabled = true;
        btn.style.background = '#64748b';
        btn.style.cursor = 'wait';
        btn.style.opacity = '0.85';
        btn.innerHTML = 'Carregando itens...';
      }

      const updateBubbleWithTickets = (tickets: ValeTransp[]) => {
        ticketsCacheRef.current[consultCode] = tickets;
        const currentContainer = document.getElementById(`bubble-tickets-container-${consultCode}`);
        if (currentContainer) {
          currentContainer.innerHTML = buildTicketsListHtml(tickets);
        }
        const emp = employeesByConsultRef.current[consultCode];
        if (emp && markersByConsultRef.current[consultCode]) {
          markersByConsultRef.current[consultCode].setData(buildEmployeeInfoBubbleHtml(emp, tickets));
        }
      };

      try {
        await apiCall({
          apiToCall: ConsultsService.getConsultResult,
          queryParams: {
            consultCode,
            codEmpresa: companyCode || 0,
            codUsu: userCode,
            perfilUsu: userProfile,
          },
          actionAfterResponse: async (response: any) => {
            if (response?.codigo && Array.isArray(response?.valeTransp) && response.valeTransp.length > 0) {
              updateBubbleWithTickets(response.valeTransp);
              return;
            }

            // Tenta fallback para Multi-Rotas caso a consulta seja do tipo MR
            await apiCall({
              apiToCall: ConsultsService.getMrConsultResult,
              queryParams: {
                consultCode,
                codEmpresa: companyCode || 0,
                codUsu: userCode,
                perfilUsu: userProfile,
              },
              actionAfterResponse: (mrResponse: any) => {
                if (mrResponse?.codigo && Array.isArray(mrResponse?.valeTransp) && mrResponse.valeTransp.length > 0) {
                  updateBubbleWithTickets(mrResponse.valeTransp);
                } else {
                  updateBubbleWithTickets([]);
                }
              },
              catchAction: () => updateBubbleWithTickets([]),
            });
          },
          catchAction: () => {
            const currentContainer = document.getElementById(`bubble-tickets-container-${consultCode}`);
            if (currentContainer) {
              currentContainer.innerHTML = `
                <div style="background: #fff5f5; border: 1px solid #feb5b5; border-radius: 4px; padding: 6px; font-size: 11px; color: #c53030; text-align: center;">
                  Não foi possível carregar os itens.
                </div>
              `;
            }
          },
        });
      } catch (err) {
        const currentContainer = document.getElementById(`bubble-tickets-container-${consultCode}`);
        if (currentContainer) {
          currentContainer.innerHTML = `
            <div style="background: #fff5f5; border: 1px solid #feb5b5; border-radius: 4px; padding: 6px; font-size: 11px; color: #c53030; text-align: center;">
              Não foi possível carregar os itens.
            </div>
          `;
        }
      }
    };

    window.addEventListener('load-routing-tickets', handleLoadTickets);
    return () => {
      window.removeEventListener('load-routing-tickets', handleLoadTickets);
    };
  }, [apiCall, userCode, userProfile]);

  return (
    <OpacityAnimation delay={0.1} style={{ overflow: 'hidden' }}>
      <div ref={mapRef} style={{ height: '70vh', width: '100%', overflow: 'hidden' }} />
    </OpacityAnimation>
  );
}
